/**
 * Replace-cart confirm — client-side only (no `mutations`/API).
 */
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useGuestCartStore } from '../store/useGuestCartStore';
import toast from 'react-hot-toast';

function ModalShell({ open, title, children, onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return createPortal(
    <div className="gc-modal-backdrop" role="presentation" onMouseDown={onClose}>
      <div className="gc-modal" role="dialog" aria-modal="true" aria-label={title} onMouseDown={(e) => e.stopPropagation()}>
        <div className="gc-modal__head">
          <div className="gc-modal__title">{title}</div>
          <button type="button" className="gc-icon-btn" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div className="gc-modal__body">{children}</div>
      </div>
    </div>,
    document.body
  );
}

export default function ConfirmReplaceCartModal() {
  const pending = useGuestCartStore((s) => s.ui.pendingReplaceConfirm);
  const linesCount = useGuestCartStore((s) => s.lines.length);
  const actions = useGuestCartStore((s) => s.actions);

  const open = Boolean(pending) && linesCount > 0;

  return (
    <ModalShell open={open} title="Start a new order?" onClose={actions.cancelReplace}>
      <div className="gc-modal__text">
        Your cart already has items from another restaurant.
        {pending?.nextRestaurant?.name ? (
          <>
            {' '}
            If you continue, we’ll clear your cart and start a new order from <strong>{pending.nextRestaurant.name}</strong>.
          </>
        ) : (
          ' If you continue, we’ll clear your cart and start a new order.'
        )}
      </div>

      <div className="gc-modal__actions">
        <button type="button" className="btn btn-outline-secondary" onClick={actions.cancelReplace}>
          Keep current cart
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {
            actions.confirmReplaceAndAdd();
            toast.success('Started a new order');
          }}
        >
          Replace cart
        </button>
      </div>
    </ModalShell>
  );
}

